import { fromJS } from "immutable";
import { ModuleRegistry } from "seneca-common/features/module/registry";

import { ModuleStudiedEvent } from "seneca-common/features/stats/state";

import { getSessionCourseId, getModuleOrderInSession } from "./session";

import {
  getContentParentId,
  getContentId,
  getContentModuleId,
  getTestingActive,
  getModuleType,
  getContent,
  getTimeStarted,
  getTimeFinished,
  getGaveUp,
  getSubmitted,
  getCompleted,
  getUserAnswer,
  getScore
} from "./sessionModule";

export function generateModuleStudiedEvent(
  state: any,
  sessionId: string,
  sessionModuleId: string,
  moduleRegistry: ModuleRegistry = ModuleRegistry.getInstance()
): ModuleStudiedEvent {
  const testingActive = getTestingActive(state, sessionId, sessionModuleId);
  const moduleType = getModuleType(state, sessionId, sessionModuleId);
  const content = getContent(state, sessionId, sessionModuleId);

  let event = new ModuleStudiedEvent({
    sessionId: sessionId,
    moduleOrder: getModuleOrderInSession(state, sessionId, sessionModuleId),
    courseId: getSessionCourseId(state, sessionId),
    sectionId: getContentParentId(state, sessionId, sessionModuleId),
    contentId: getContentId(state, sessionId, sessionModuleId),
    moduleId: getContentModuleId(state, sessionId, sessionModuleId),
    moduleType,
    testingActive,
    content,
    timeStarted: getTimeStarted(state, sessionId, sessionModuleId),
    timeFinished: getTimeFinished(state, sessionId, sessionModuleId),
    gaveUp: getGaveUp(state, sessionId, sessionModuleId),
    submitted: getSubmitted(state, sessionId, sessionModuleId),
    completed: getCompleted(state, sessionId, sessionModuleId)
  });

  if (testingActive) {
    const userAnswer = getUserAnswer(state, sessionId, sessionModuleId);
    const markAnswer = moduleRegistry.modules
      .getModule(moduleType)
      .getMarkAnswer();
    event = event
      .set("userAnswer", userAnswer)
      .set("score", getScore(state, sessionId, sessionModuleId))
      .set(
        "moduleScore",
        fromJS(
          markAnswer(
            content && content.toJS ? content.toJS() : null,
            userAnswer && userAnswer.toJS ? userAnswer.toJS() : null
          )
        )
      );
  }

  return event;
}
